import { addMonths, format } from "date-fns";

import { GoalBasedFinancingMethodSchema } from "@fartherfinance/frontend/api/FinancialPlans/goals/types";
import { GoalBasedFinancialPlanDateId } from "@fartherfinance/frontend/api/FinancialPlans/ids";
import { GoalBasedPlanDateTypeSchema } from "@fartherfinance/frontend/api/FinancialPlans/types";
import { ClientId } from "@fartherfinance/frontend/api/Types";

import { FinancingMethod } from "@src/multiCustodian/components/FinancialPlans/CreateUpdatePlanFlow/pages/Shared/Types";

interface Params {
  startDate: Date | undefined;
  term: string;
  financingMethod: FinancingMethod;
  ownerId: ClientId;
  endPlanDateId?: GoalBasedFinancialPlanDateId;
}

export const calculateFinancingMethodEndDate = ({
  startDate,
  term,
  financingMethod,
  ownerId,
  endPlanDateId,
}: Params) => {
  if (startDate === undefined) {
    throw new Error("Start date is required");
  }

  if (financingMethod === GoalBasedFinancingMethodSchema.Enum.Cash) {
    return null; // don't want an endDate as the plan date is a target date
  }

  const endDate = addMonths(startDate, parseInt(term));

  return {
    owner: ownerId,
    planDateId: endPlanDateId,
    value: format(endDate, "yyyy-MM-dd"),
    dateType: GoalBasedPlanDateTypeSchema.Enum.DateString,
  };
};
